import { userTimezone } from "common/Timezone";

export interface Interval {
    cron: string;
    timezone: string;
}

export const createInterval = (cron = ""): Interval => ({cron, timezone: userTimezone()});

export const normalizeInterval = (value?: Interval | string | null): Interval => {
    if (typeof value === "string") {
        return {cron: value, timezone: value.trim() ? "UTC" : userTimezone()};
    }
    const cron = value?.cron ?? "";
    return {
        cron,
        timezone: value?.timezone?.trim() || (cron.trim() ? "UTC" : userTimezone()),
    };
};
